/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const UserAvatarCursorIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'User Avatar Cursor',
} = {}): string | TemplateResult => {
  return html`<svg
    data-name="strokes"
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M10,1.25C5.1748,1.25,1.25,5.1748,1.25,10s3.9248,8.75,8.75,8.75c.33594,0,.66602-.01953.99121-.05566.41211-.0459.70801-.41699.66211-.82812-.04492-.41113-.41504-.69922-.82812-.66211-.27051.03027-.5459.0459-.8252.0459-1.82861,0-3.49609-.68555-4.77283-1.80615,1.06995-1.18799,3.26868-1.90674,5.40076-1.73877.4082.03516.77441-.27344.80762-.68652.03418-.41211-.27344-.77441-.68652-.80762-2.53418-.2041-5.12524.65479-6.53784,2.13574-.91309-1.21289-1.46118-2.71509-1.46118-4.34668,0-3.99805,3.25195-7.25,7.25-7.25s7.25,3.25195,7.25,7.25c0,.37207-.02832.74609-.08496,1.1123-.06348.40918.21777.79199.62695.85547.41016.06836.79297-.21777.85547-.62695.06836-.44141.10254-.89258.10254-1.34082,0-4.8252-3.9248-8.75-8.75-8.75Z"
      fill="currentColor"
    />
    <path
      d="M10.05371,11c-.02051,0-.01758-.01562-.06152-.00098-.59082,0-1.16602-.16797-1.66504-.48535-.49023-.31348-.89062-.75098-1.1582-1.26562-.2832-.53906-.42773-1.14746-.41797-1.75781-.02344-1.17578.56348-2.28711,1.57129-2.94629,1.01855-.64844,2.32715-.64941,3.3418-.00488.49121.31836.89062.75293,1.16309,1.25977.28223.51953.42871,1.1123.42285,1.71094.00977.5918-.13574,1.20215-.41895,1.74609-.26855.51465-.66895.9541-1.1582,1.27051-.48828.31055-1.0459.47363-1.61914.47363ZM10.00977,9.49902h.00977c.30664-.00391.5918-.07422.84277-.23535.26758-.17285.48926-.41602.63867-.70215.16895-.32324.25488-.68555.24902-1.04785.00391-.36328-.08008-.70312-.24316-1.00195-.1543-.28906-.37988-.5332-.65332-.71094-.51953-.33008-1.19531-.33008-1.71875.00391-.56445.36914-.89746,1-.88379,1.68262-.00586.38672.08008.74609.24707,1.06543.14844.28418.36816.52441.63672.69629.25586.16309.55273.25.8584.25h.0166Z"
      fill="currentColor"
    />
    <path
      d="M14.25781,18.36133c-.16113,0-.32422-.03125-.47949-.09473-.47266-.19531-.77832-.65137-.77832-1.16211v-4.37012c0-.50977.30371-.96484.77441-1.16016.47363-.19531,1.01074-.08887,1.36914.27051l2.98633,2.97754c.36426.36426.4707.91113.27051,1.39453-.19727.47559-.65137.7832-1.1582.7832h-1.11426l-.97852.98828c-.24219.24414-.56348.37305-.8916.37305ZM14.5,13.32129v3.19141l.66504-.67188c.22363-.22656.52441-.34082.89258-.34082h.62793l-2.18555-2.17871Z"
      fill="currentColor"
    />
  </svg>`;
};
